import React, { useState, useEffect } from 'react';
import { NeoBadge } from '../../../../../components/Common';
import ProfileTabList from '../ProfileTabList';
import TaskService from '../../../../../services/task_service';
import { useTenant } from '../../../../../hooks/useTenant';

const STATUS_COLORS = {
    new: "info",
    in_progress: "warning",
    completed: "success",
    done: "success",
    archived: "secondary",
    canceled: "danger",
    scheduled: "primary"
};

const STATUS_LABELS = {
    new: "Novo",
    in_progress: "Em Andamento",
    completed: "Concluído",
    done: "Concluído",
    archived: "Arquivado",
    canceled: "Cancelado",
    scheduled: "Agendado"
};

const ProfileContacts = ({ memberId }) => {
    const { idTenant } = useTenant();
    const [tasks, setTasks] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchTasks = async () => {
            if (!idTenant || !memberId) return;
            setLoading(true);
            try {
                const data = await TaskService.getTasksByMember(idTenant, memberId);
                setTasks(data);
            } catch (error) {
                console.error("Erro ao carregar histórico de contatos/tarefas:", error);
            } finally {
                setLoading(false);
            }
        };

        fetchTasks();
    }, [idTenant, memberId]);

    const formatTimeAgo = (timestamp) => {
        if (!timestamp) return '';
        try {
            const date = timestamp.toDate ? timestamp.toDate() : new Date(timestamp);
            return new Intl.DateTimeFormat('pt-BR', { day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit' }).format(date);
        } catch {
            return '';
        }
    };

    const columns = [
        {
            label: "Data / Hora",
            key: "createdAt",
            render: (row) => formatTimeAgo(row.createdAt),
            width: "15%"
        },
        {
            label: "Contato / Tarefa",
            key: "title",
            render: (row) => (
                <div>
                    <div className="fw-medium text-dark">{row.title}</div>
                    <div className="text-muted font-size-12 mt-1">{row.description}</div>
                    {row.comments && row.comments.length > 0 && (
                        <div className="mt-2 bg-light p-2 rounded border border-dashed font-size-12 text-muted">
                            <i className="mdi mdi-comment-outline me-1"></i>
                            <strong>Último comentário:</strong> {row.comments[row.comments.length - 1].text}
                        </div>
                    )}
                </div>
            ),
            width: "50%"
        },
        {
            label: "Responsável",
            key: "employeeName",
            render: (row) => (
                <div className="text-muted font-size-12">
                    {row.employeeName || row.createdBy?.name || 'Sistema'}
                </div>
            ),
            width: "20%"
        },
        {
            label: "Status",
            key: "status",
            render: (row) => {
                const color = STATUS_COLORS[row.status] || "secondary";
                const label = STATUS_LABELS[row.status] || row.status;
                return (
                    <NeoBadge color={color} className="px-3 py-1 font-size-12">
                        {label}
                    </NeoBadge>
                );
            },
            width: "15%",
            className: "text-center"
        }
    ];

    return (
        <ProfileTabList
            title="Histórico de Contatos"
            description="Acompanhe todas as interações, tarefas e chamados vinculados a este aluno(a)."
            icon="mdi-phone-message-outline"
            columns={columns}
            data={tasks}
            isLoading={loading}
            emptyMessage="Nenhum contato ou tarefa registrada."
            keyField="id"
        />
    );
};

export default ProfileContacts;
